import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { loadDictionary, type Language } from '@/lib/i18n/dictionary';

// Resolve the active language from URL → localStorage → default.
function resolveActiveLang(): Language {
  try {
    const seg = window.location.pathname.split('/')[1];
    if (seg === 'ru' || seg === 'en' || seg === 'uz') return seg;
    const saved = localStorage.getItem('language');
    if (saved === 'ru' || saved === 'en' || saved === 'uz') return saved as Language;
  } catch { /* swallow */ }
  return 'ru';
}

// IMPORTANT: We MUST await the active-language dictionary BEFORE mounting React.
// Otherwise t('nav.home') returns the raw key 'nav.home' on the first render(s)
// until the dynamic chunk arrives — that's the "NAV.HOME / BOSH SAHIFA"
// flash the user sees on cold load and on language switch.
//
// The cost is one dynamic import (~50 KB gzip) before first paint, but it
// happens in parallel with React/CSS so the actual added latency is ~50-150 ms
// on a normal connection (and 0 ms on repeat visits — HTTP cache hit).
const activeLang = resolveActiveLang();

loadDictionary(activeLang)
  .catch(() => { /* dictionary failed — t() will fall back to raw keys, but no crash */ })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
